import React, { useState } from "react";
import { Button, DatePicker, Heading, Modal, Paper } from "src/components";
import { Colors } from "src/types";
import { useEffect } from "react";
import { theme } from "src/config";
import Box from "react-raster";
import { ColorPicker } from "src/components/colorpicker";

export const ModalSection = () => {
  const [showModal, setShowModal] = useState("");
  const [date, setDate] = React.useState<Date>(new Date());
  const [color, setColor] = useState("#aabbcc");

  useEffect(() => {
    showModal
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "visible");
    document.addEventListener("click", onclick, false);
    return () => {
      document.removeEventListener("click", onclick, false);
    };
  }, [showModal]);

  return (
    <Box>
      <Box
        colspan={3}
        gridRowGap={theme.layout.gutterSmall}
        gridColumnGap={theme.layout.gutterSmall}
      >
              <Heading weight="normal" type="h3" color="black">Modals</Heading>
        <Box cols={3}>
          <hr />
        </Box>
        <Button onClick={() => setShowModal("modal-1")} size="default">
          Show modal
        </Button>

        <Modal show={showModal == "modal-1"} onClose={() => setShowModal("")}>
          <ColorPicker value={color} onClose={setColor} />
          <Box minWidth="500px" minHeight="500px">
            <DatePicker
              value={date}
              onChange={setDate}
              calendarProps={{
                editable: true,
                selectable: true,
                weekNumbers: true,
                handleWindowResize: true
              }}
            />
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};
